/**
 * @generated SignedSource<<4f0c42e8f4f3a82868d099d499e0eddf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type unified_ingest_transform_templates_edit_params = {
  is_displayable?: boolean | null;
  is_production?: boolean | null;
  owner_name: string;
  template_uuid: string;
};
export type useUnifiedIngestEditTemplatesMutation$variables = {
  params: unified_ingest_transform_templates_edit_params;
};
export type useUnifiedIngestEditTemplatesMutation$data = {
  readonly unified_ingest_transform_templates_edit: {
    readonly owner_name: string;
    readonly template_data: {
      readonly example_file_id: string | null;
      readonly file_type: string | null;
      readonly is_production: boolean | null;
      readonly org_slug: string | null;
      readonly source_system: string | null;
      readonly steps: any | null;
      readonly target_table: string | null;
      readonly template_display_name: string | null;
      readonly template_id: string | null;
      readonly user_id: string | null;
    };
  } | null;
};
export type useUnifiedIngestEditTemplatesMutation = {
  response: useUnifiedIngestEditTemplatesMutation$data;
  variables: useUnifiedIngestEditTemplatesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "params"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "params",
        "variableName": "params"
      }
    ],
    "concreteType": "unified_ingest_transform_templates_read_output",
    "kind": "LinkedField",
    "name": "unified_ingest_transform_templates_edit",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "owner_name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "unified_ingest_transform_templates_list_output_template_data",
        "kind": "LinkedField",
        "name": "template_data",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "user_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "org_slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "template_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "template_display_name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "is_production",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "source_system",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "target_table",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "file_type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "example_file_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "steps",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUnifiedIngestEditTemplatesMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUnifiedIngestEditTemplatesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c2743fc6bfb8908db685ec3ed08acfc4",
    "id": null,
    "metadata": {},
    "name": "useUnifiedIngestEditTemplatesMutation",
    "operationKind": "mutation",
    "text": "mutation useUnifiedIngestEditTemplatesMutation(\n  $params: unified_ingest_transform_templates_edit_params!\n) {\n  unified_ingest_transform_templates_edit(params: $params) {\n    owner_name\n    template_data {\n      user_id\n      org_slug\n      template_id\n      template_display_name\n      is_production\n      source_system\n      target_table\n      file_type\n      example_file_id\n      steps\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "00a09df80340a25d61410a5b509329ab";

export default node;
